/**
 * Whether the assistant could read an attached file's text (#6504).
 *
 * Numbers, because the API serializes with Newtonsoft.Json and registers no string-enum converter.
 * `Unread` is 0, so beware `state || fallback`. Must stay aligned with `AssistantAttachmentTextState`
 * in `api/AIAssistant`.
 */
export enum AssistantAttachmentTextState {
  /** Nothing has tried to read it yet. */
  Unread = 0,
  /** Read, and the text is kept. */
  Read = 1,
  /** Not read yet for a reason that passes: its malware scan, or the reader being unavailable. */
  NotReadYet = 2,
  /** Read, and it holds no text: a scan with no recognizable words, say. */
  NoText = 3,
  /** Its text is longer than the assistant reads. */
  TooLong = 4,
  /** It cannot be read: damaged, or a format the reader refuses. */
  Unreadable = 5,
  /** Its malware scan found it infected, or could not scan it. It is never read. */
  Withheld = 6,
}
